import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gossip";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 " +
        (scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent")
      }
    >
      <div className="mx-auto flex h-16 max-w-[1240px] items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
            瓜
          </span>
          <span className={"font-heading text-xl font-black tracking-wide " + (scrolled ? "text-foreground-950" : "text-white")}>
            吃瓜吧
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              className={
                "rounded-md px-3.5 py-2 text-sm transition " +
                (scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                  : "text-white/85 hover:bg-white/15 hover:text-white")
              }
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div
            className={
              "hidden items-center gap-2 rounded-full border px-3 py-2 transition lg:flex " +
              (scrolled ? "border-background-300 bg-background-100" : "border-white/30 bg-white/10")
            }
          >
            <i className={"ri-search-line text-sm " + (scrolled ? "text-foreground-500" : "text-white/80")}></i>
            <input
              placeholder="搜瓜、搜楼、搜瓜友"
              className={
                "w-40 bg-transparent text-sm outline-none placeholder:font-light " +
                (scrolled ? "placeholder:text-foreground-400 text-foreground-950" : "placeholder:text-white/60 text-white")
              }
            />
          </div>
          <button className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 md:inline-flex md:items-center">
            <i className="ri-edit-2-line mr-1.5 text-sm"></i>盖楼发帖
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            className={
              "flex h-10 w-10 items-center justify-center rounded-md md:hidden " +
              (scrolled ? "text-foreground-950" : "text-white")
            }
            aria-label="打开菜单"
          >
            <i className={"text-xl " + (open ? "ri-close-line" : "ri-menu-line")}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              onClick={() => setOpen(false)}
              className="block rounded-md px-2 py-3 text-sm text-foreground-800 hover:bg-background-100"
            >
              {l.label}
            </a>
          ))}
          <button className="mt-2 flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50">
            <i className="ri-edit-2-line mr-1.5 text-sm"></i>盖楼发帖
          </button>
        </div>
      )}
    </header>
  );
}